import {
  useState,
  useEffect,
  Dispatch,
  SetStateAction,
} from 'react';

type SortOrder = 'asc' | 'desc';

interface EnhancedTableState {
  setRows: Dispatch<SetStateAction<unknown[]>>;
  rowCount: number;
  setRowCount: Dispatch<SetStateAction<number>>;
  pageIndex: number;
  setPageIndex: Dispatch<SetStateAction<number>>;
  order: SortOrder;
  orderBy: string;
  setOrder: Dispatch<SetStateAction<SortOrder>>;
  pageSize?: number | undefined;
}

interface UseEnhancedTableOptions {
  onChange?: (state: EnhancedTableState) => void;
  pageSize?: number;
}

export function useEnhancedTable(options: UseEnhancedTableOptions) {
  const [order, setOrder] = useState<SortOrder>('asc');
  const [orderBy, setOrderBy] = useState('');

  const [pageIndex, setPageIndex] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [rows, setRows] = useState<unknown[]>([]);

  const {
    onChange,
    pageSize,
  } = options;

  useEffect(() => {
    if (!onChange) {
      return;
    }

    onChange({
      setRows,
      rowCount,
      setRowCount,
      pageIndex,
      setPageIndex,
      order,
      orderBy,
      setOrder,
      pageSize,
    });
  }, [order, orderBy, pageIndex]);

  const createSortHandler = (property: string) => (_event: unknown) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return {
    pageSize: pageSize || 0,

    order,
    orderBy,

    pageIndex,
    setPageIndex,
    rowCount,
    setRowCount,
    rows,
    setRows,

    createSortHandler,
  };
}
